import { Record } from "@common/data-models/records/record";
import { ObjectTypes } from "@common/enums/object-types";

export class ExportFormatRecord extends Record {
    constructor() {
        super();

        this.type = ObjectTypes.EXPORTFORMAT;
    }

    public get exportFormatType(): number { return this.getAs<number>("PSTExportFormatType"); }
    public set exportFormatType(value: number) { this.set("PSTExportFormatType", value); }

    public get exportFormatTemplate(): string { return this.getAs<string>("PSTExportFormatTemplate"); }
    public set exportFormatTemplate(value: string) { this.set("PSTExportFormatTemplate", value); }

    public get exportFormatSourceObjectType(): number { return this.getAs<number>("PSTExportSourceObjectType"); }
    public set exportFormatSourceObjectType(value: number) { this.set("PSTExportSourceObjectType", value); }

}

